export const TOGGLE_LOADING = "TOGGLE_LOADING";
export const SET_FIRST_NAME = "SET_FIRST_NAME";
export const SET_LAST_NAME = "SET_LAST_NAME";
export const SET_ORDER_NUMBER = "SET_ORDER_NUMBER";
export const SET_EMAIL_ADDRESS = "SET_EMAIL_ADDRESS";
export const SET_REASON = "SET_REASON";

export const initialState = {
  loading: true,
  cancellationFormDetails: {},
};

export const toggleLoading = () => ({
  type: TOGGLE_LOADING,
});

export const setFirstName = (firstName) => ({
  type: SET_FIRST_NAME,
  firstName,
});

export const setLastName = (lastName) => ({
  type: SET_LAST_NAME,
  lastName,
});

export const setOrderNumber = (orderNumber) => ({
  type: SET_ORDER_NUMBER,
  orderNumber,
});

export const setEmailAddress = (email) => ({
  type: SET_EMAIL_ADDRESS,
  email,
});

export const setReason = (reason) => ({
  type: SET_REASON,
  reason,
});

// eslint-disable-next-line complexity
export const cancellationFormDetailsReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case TOGGLE_LOADING:
      return {
        ...state,
        loading: !state.loading,
      };
    case SET_FIRST_NAME:
      return {
        ...state,
        cancellationFormDetails: {
          ...state.cancellationFormDetails,
          firstName: action.firstName,
        },
      };
    case SET_LAST_NAME:
      return {
        ...state,
        cancellationFormDetails: {
          ...state.cancellationFormDetails,
          lastName: action.lastName,
        },
      };
    case SET_ORDER_NUMBER:
      return {
        ...state,
        cancellationFormDetails: {
          ...state.cancellationFormDetails,
          orderNumber: action.orderNumber,
        },
      };
    case SET_EMAIL_ADDRESS:
      return {
        ...state,
        cancellationFormDetails: {
          ...state.cancellationFormDetails,
          email: action.email,
        },
      };
    case SET_REASON:
      return {
        ...state,
        cancellationFormDetails: {
          ...state.cancellationFormDetails,
          reason: action.reason,
        },
      };
    default:
      return state;
  }
};
